export const useAccountHasAccess = ({
  isTrialing,
  isTrialingCompanies,
  isTrialingTeams,
}: {
  isTrialing: boolean;
  isTrialingCompanies: boolean;
  isTrialingTeams: boolean;
}) => {
  return {
    hasAccess: isTrialing && !isTrialingCompanies && !isTrialingTeams,
  };
};
